__turbopack_context__.v({
  "body": "InStockCTA-module__a8ETrG__body",
  "content": "InStockCTA-module__a8ETrG__content",
  "copy": "InStockCTA-module__a8ETrG__copy",
  "ctaSection": "InStockCTA-module__a8ETrG__ctaSection",
  "desktopMedia": "InStockCTA-module__a8ETrG__desktopMedia",
  "mobileMedia": "InStockCTA-module__a8ETrG__mobileMedia",
  "scrim": "InStockCTA-module__a8ETrG__scrim",
  "title": "InStockCTA-module__a8ETrG__title",
  "titleMuted": "InStockCTA-module__a8ETrG__titleMuted",
});
